import styled from 'styled-components';

const FilterLabel = styled.span`
    font-size: 12px;
    margin-left: -8px;
    width: 200px;
`;

export default FilterLabel;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/FilterLabel.js